import { useMemo } from 'react';
import { ScopeEnum } from 'src/domain';
import { useScope } from 'src/hooks/useScope';
import { AuditLogEnum } from 'src/infrastructure/rest-api/api-types';
import { components } from 'src/infrastructure/rest-api/generated';
import { useApiQuery } from 'src/infrastructure/rest-api/useApi';

export const useAuditLogOverviewApiQuery = (
    entityId: number | string | null | undefined,
    entityType: components['schemas']['EntityTypeEnum'],
    module: AuditLogEnum | null,
    enable = false
) => {
    const scope = useScope();

    const scopeMatches = useMemo(() => {
        switch (entityType) {
            case 'Store':
                return scope === ScopeEnum.STORE;
            case 'Cluster':
                return scope === ScopeEnum.CLUSTER;
            case 'Partner':
                return scope === ScopeEnum.PARTNER;
            default:
                return false;
        }
    }, [entityType, scope]);

    const { data, loading, error } = useApiQuery('/api/auditlogs/modules/{module}', 'get', {
        query: {
            entityId: Number(entityId),
            entityType,
        },
        path: {
            module,
        },
        enabled: !!entityId && !Number.isNaN(Number(entityId)) && !!module && scopeMatches && enable,
    });

    return { data, loading, error };
};
